import type { RouteRecordRaw } from 'vue-router';

export interface ModuleDefinition {
    name: string;
    routes: RouteRecordRaw[];
}

export function defineModule(def: ModuleDefinition): ModuleDefinition {
    if (!def.name) {
        throw new Error('Module must have a name');
    }

    if (!Array.isArray(def.routes)) {
        throw new Error(`Module "${def.name}" must export routes[]`);
    }

    return def;
}
